module.exports = __webpack_public_path__ + "media/images/footer_page/about/about-step2-be0cbee4a58d99d81fc0e94309f867a2.svg";